import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './pages/App/App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import getAuthConfig from './authConfig';
import store from './redux/store';
import { I18nextProvider } from 'react-i18next';
import { HelmetProvider } from "react-helmet-async";
import i18n, { initializeI18n } from './assets/i18n/i18n';
import MetaTags from './providers/MetaTags';

const authConfig: any = { ...getAuthConfig };
const pca = new PublicClientApplication(authConfig);

const startApp = async () => {
  await initializeI18n()
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <MsalProvider instance={pca}>
      <I18nextProvider i18n={i18n}>
      <Provider store={store}>
       <HelmetProvider>
       <BrowserRouter>
       <MetaTags />
       <App />  
        </BrowserRouter>
        </HelmetProvider>
      </Provider>
      </I18nextProvider>
    </MsalProvider>
  </React.StrictMode>
);
}

startApp().catch((error) => {
  console.error('Error starting the app:', error);
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
